module.exports = __webpack_public_path__ + "media/3.3712079f.mp3";